export default "__VITE_ASSET__ff53d980__"